export default defineAppConfig({
  ui: {
    notifications: {
      position: 'top-10 bottom-[unset]',
      wrapper: 'w-full pointer-events-auto z-[1100]'
    }
  }
})
